<template>
  <nav>
    <ul class="nav blanklist">
      <li class="nav-item">
        <button
          type="button"
          value="*"
          class="btn nav-link px-0"
          @click="changeCategory('')"
          :class="{ active: !currentCategory.slug }"
        >
          Alle
        </button>
      </li>
      <li v-for="cat in blogCategories" :key="cat.slug" class="nav-item ms-1">
        <button
          type="button"
          @click="changeCategory(cat.slug)"
          class="btn nav-link px-0"
          :value="cat.id"
          :class="{ active: cat.slug == currentCategory.slug }"
        >
          {{ cat.name }}
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import { useBlogStore } from '~/stores/blog';
import { useContext, computed, useRouter } from '@nuxtjs/composition-api';
export default {
  name: 'CategoryFilter',
  props: {
    blogCategories: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const blogStore = useBlogStore();
    const order = computed(() => blogStore.order);
    const categories = computed(() => blogStore.categories);
    const currentCategory = computed(() => blogStore.currentCategory);
    const app = useContext();
    const totalPosts = computed(() => blogStore.totalPosts);

    const router = useRouter();

    const changeCategory = async (slug) => {
      blogStore.setCurrentCategory(slug);
      blogStore.setLoaded(false);
      blogStore.setCategories(categories.value);

      await blogStore.reloadPosts(10, order.value);

      if (slug) {
        await router.push({ path: '/blog', query: { c: slug } });
      } else {
        await router.push({ path: '/blog/' });
      }
    };

    return {
      changeCategory,
      currentCategory: currentCategory.value,
      totalPosts: totalPosts.value,
    };
  },
};
</script>

<style lang="scss" scoped>
.postsLists.loading {
  position: relative;
  &:before {
    content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: #eee;
    opacity: 0.5;
  }
}

.nav {
  display: flex;
  justify-content: space-between;
  width: 100%;

  li {
    button {
      font-weight: 400;
      position: relative;
      padding: 5px 0;
      transition: $transition-base;

      &::after {
        content: '';
        width: 0;
        height: 2px;
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        background: $primary;
        transition: $transition-base;
      }

      &:hover,
      &.active {
        font-weight: 500;

        &::after {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: $lg) {
    min-width: $xl;
  }

  @media (max-width: $md) {
    min-width: $lg;

    li {
      button {
        font-size: 14px;
      }
    }
  }

  @media (max-width: $sm) {
    min-width: 640px;
  }
}
</style>
